import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">Rosslyn Cannabis · Informational Hub</p>
        <h1>Welcome to Rosslyn Cannabis</h1>
        <p className="lede">
          Your go-to source for the latest news and information on cannabis policy and culture in our community. 
          Stay informed about local laws, legal status updates, and educational resources.
        </p>
        <div className="cta-row">
          <a href="/latest-news" target="_self">
            Explore Latest News
          </a>
          <a href="/educational-resources" target="_self" className="secondary">
            Access Educational Resources
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Local Law Updates</h2>
          <p>
            Stay updated with the latest changes in cannabis legislation and regulations affecting our area.
          </p>
        </article>
        <article>
          <h2>Understanding Legal Status</h2>
          <p>
            Get clear information on the legal status of cannabis in our community and what it means for residents.
          </p>
        </article>
        <article>
          <h2>Educational Guides</h2>
          <p>
            Access comprehensive guides and articles to educate yourself about cannabis culture and policy.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;